module.exports = __webpack_public_path__ + "static/media/22ESCWA24.26a8a94e.jpg";